import type { Theme } from '@mui/material/styles';

import type { DiagramSeriesGroupId } from '../types/DiagramSeries.types';
import type { SeriesSelection } from '../types/SeriesSelection.types';
import { PATH_SERIES_ID } from './diagramIdentifiers';

/** Groups in the order the selector lists them; mirrors the keys of the measure channels response. */
export const DIAGRAM_SERIES_GROUP_IDS = [
  'speed',
  'channels',
  'states',
] as const satisfies readonly DiagramSeriesGroupId[];

/** Colours fixed by iTrack convention regardless of palette order (a red speed graph is established). */
export const FIXED_SERIES_COLORS: Partial<Record<string, (theme: Theme) => string>> = {
  [PATH_SERIES_ID.SPEED]: (theme) => theme.palette.error.main,
  [PATH_SERIES_ID.IGNITION]: (theme) => theme.palette.warning.main,
};

/** The speed graph is the one series every target starts with; everything else is opt-in. */
export const DEFAULT_SERIES_SELECTION: SeriesSelection = {
  selectedSeriesIds: [PATH_SERIES_ID.SPEED],
  highlightedSeriesIds: [],
};

export const EMPTY_SERIES_SELECTION: SeriesSelection = {
  selectedSeriesIds: [],
  highlightedSeriesIds: [],
};

/**
 * Selection remembered per target, user-scoped through the preferences hook. One key holds a map,
 * because the preferences hook reads storage only on mount and would carry stale state across a
 * changing key. `:v1` guards a future shape change.
 */
export const SELECTION_PREFERENCES_KEY = 'timeSeriesChart.selection:v1';
export const MAX_REMEMBERED_TARGETS = 30;
